exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-438e57d6]{margin-top:35px}.handle[data-v-438e57d6]{float:left}.close[data-v-438e57d6],.handle[data-v-438e57d6]{padding-top:8px;padding-bottom:8px}.close[data-v-438e57d6]{float:right}input[data-v-438e57d6]{display:inline-block;width:50%}.text[data-v-438e57d6]{margin:20px}", ""]);

// exports
